/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioContentTestMatch } from './InternalApiScenarioContentTestMatch';
import {
    InternalApiScenarioContentTestMatchFromJSON,
    InternalApiScenarioContentTestMatchFromJSONTyped,
    InternalApiScenarioContentTestMatchToJSON,
    InternalApiScenarioContentTestMatchToJSONTyped,
} from './InternalApiScenarioContentTestMatch';

/**
 * Scenario content test results with applied alert interval
 * @export
 * @interface InternalApiScenarioContentTestResult
 */
export interface InternalApiScenarioContentTestResult {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioContentTestResult
     */
    alertingInterval: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioContentTestResult
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiScenarioContentTestMatch>}
     * @memberof InternalApiScenarioContentTestResult
     */
    matches: Array<InternalApiScenarioContentTestMatch>;
}

/**
 * Check if a given object implements the InternalApiScenarioContentTestResult interface.
 */
export function instanceOfInternalApiScenarioContentTestResult(value: object): value is InternalApiScenarioContentTestResult {
    if (!('alertingInterval' in value) || value['alertingInterval'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('matches' in value) || value['matches'] === undefined) return false;
    return true;
}

export function InternalApiScenarioContentTestResultFromJSON(json: any): InternalApiScenarioContentTestResult {
    return InternalApiScenarioContentTestResultFromJSONTyped(json, false);
}

export function InternalApiScenarioContentTestResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioContentTestResult {
    if (json == null) {
        return json;
    }
    return {
        
        'alertingInterval': json['alertingInterval'],
        'total': json['total'],
        'matches': ((json['matches'] as Array<any>).map(InternalApiScenarioContentTestMatchFromJSON)),
    };
}

export function InternalApiScenarioContentTestResultToJSON(json: any): InternalApiScenarioContentTestResult {
    return InternalApiScenarioContentTestResultToJSONTyped(json, false);
}

export function InternalApiScenarioContentTestResultToJSONTyped(value?: InternalApiScenarioContentTestResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alertingInterval': value['alertingInterval'],
        'total': value['total'],
        'matches': ((value['matches'] as Array<any>).map(InternalApiScenarioContentTestMatchToJSON)),
    };
}

